<template>
  <div class="page-cost-center">
	<header-page
		search-header
		:title="$route.meta.title"
		:show-false="false"
		:show-clean="false"
		@on-search-event="onSearch"
		>
		</header-page>
		<app-actions
			class="action-mobile"
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<div class="cost-center">
			<!-- <app-table
			class="is-not-selectable"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			:columns="columns"
			:input-search="true"
			name="cost-center"
			@on-page="changePage"
			@on-search-event="onSearch"
			@create-action="createAction"
			>
				<template slot="rows" slot-scope="props">
					<td v-show="showRow(columns, 1)" class="is-not-selectable">{{ props.row.code }}</td>
					<td v-show="showRow(columns, 2)" class="name-column">{{ props.row.name }}</td>
					<td v-show="showRow(columns, 3)" :style="colorState(props.row)" >
						<span class="state-desktop">
							{{ stateName(props.row) }}
						</span>
						<span class="state-responsive">
							<app-tooltip-button
								:text="stateName(props.row)"
								icon="radio_button_checked"
								:color="statusColorResponsive(props.row)"
							/>
						</span>
					</td>
					<td v-show="showRow(columns, 4)" class="actions">
								<app-tooltip-button
									class="no-movil"
									img="/static/img/actions-list/edit.svg"
									text="Editar Centro de costo"
									:width="iconWidth"
									@click-icon="openModalCost(props.row)"
								/>
								<app-tooltip-button
									class="no-movil"
									img="/static/img/actions-list/delete.svg"
									text="Eliminar Centro de Costo"
									:width="iconWidth"
									@click-icon="openModalDelete(props.row)"
								/>
						<div class="collapse-menu">
							<v-menu>
								<v-btn dark icon slot="activator">
									<v-icon>more_horiz</v-icon>
								</v-btn>
								<v-list>
									<v-list-tile class="btn-menu-content" @click="openModalCost(props.row)">
										<v-list-tile-title class="menu-content">
											<img
											src="/static/img/actions-list/edit.svg"
											alt="icon-edit"
											class="menu-option-icon"
											width="15px"
											height="15px"
											>
											<span class="ml-1 text-edit-mobile">Editar</span>
										</v-list-tile-title>
									</v-list-tile>
									<v-list-tile class="btn-menu-content" @click="openModalDelete(props.row)">
										<v-list-tile-title class="menu-content">
											<img src="/static/img/actions-list/delete.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
											>
											<span class="ml-1 text-delete-mobile">Eliminar</span>
										</v-list-tile-title>
									</v-list-tile>
								</v-list>
							</v-menu>
						</div>
					</td>
				</template>
			</app-table> -->
		</div>
		<tree-table
				:tree-data="rows"
				:can-create="canCreate"
				:can-edit="canEdit"
				:can-delete="canDelete"
				@click-icon="onClickIcon"></tree-table>
		<action-bar
		class="action-mobile"
		:resource-uri="$route.name"
		@run-action="runAction"
		/>
		<action-sidebar
		:title="action.title"
		:value="action.value"
		:width="action.width"
		@close-modal="closeModal"
		>
			<create-cost-center
			:model="model"
			:disabled-code="disabledCode"
			:subsidiary="currentSubsidiary"
			:loading="loading"
			@edit-center="editCenter"
			@close-modal="closeModal"
			@create-cost="createCost"
			/>
		</action-sidebar>
		<v-dialog
		content-class="confirmation-dialog"
		v-model="openConfirmationModal"
		max-width="400"
		>
			<v-card class="pa-4">
				<v-card-text class="title text-xs-center pt-4">{{dialogMessage}}</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<button
					type="button"
					class="btn-modal cancel mr-2"
					@click="closeDialog"
					>No</button>
					<button
					type="button"
					class="btn-modal save ml-2"
					@click="onDeleteCost"
					>
					Si
					</button>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import actionBar from '@/components/shared/action-bar/action-bar';
import actionSidebar from '@/components/shared/action-sidebar';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import createCostCenter from '@/components/new-cost-center/create-cost-center';
import appActions from '@/components/shared/app-actions/app-actions';
import treeTable from '@/components/shared/tree-table';

// Recurso ACL de esta pantalla (= $route.name). En tu mapa: 'center-of-cost'.
// Cada acción se gatea con SU propio código de la parametrización:
//   - Botón superior "Nuevo Centro de Costo" -> 'cost-center-new'
//     (lo filtran app-actions / action-bar, ver runAction)
//   - Agregar hijo (icono + en la fila)      -> 'create'
//   - Editar (icono lápiz)                   -> 'update'
//   - Eliminar (icono basura)                -> 'delete'
// Si el código no está marcado en la configuración, $can da false y el
// icono correspondiente se oculta y la acción se bloquea.
function permsResource() {
	return (this.$route && this.$route.name) || '';
}
// Crear centro RAÍZ desde el botón superior.
function canNewRoot() {
	return this.$can(this.permsResource, 'cost-center-new');
}
// Agregar hijo desde el árbol (CRUD "Crear").
function canCreate() {
	return this.$can(this.permsResource, 'create');
}
function canEdit() {
	return this.$can(this.permsResource, 'update');
}
function canDelete() {
	return this.$can(this.permsResource, 'delete');
}

function created() {
	this.setId({ documentNumber: this.currentSubsidiary.documentNumber,
		id: this.currentSubsidiary.id },
	'subsidiaryId',
	);
}

function createAction() {
	this.action = {
		code: 'cost-center-new',
		title: 'Nuevo centro de costos',
		value: true,
	};
}

function onSearch(value) {
	this.currentPage = 1;
	this.params.page = this.currentPage;
	this.params.search = value ? value.trim() : null;
	this.setId({ documentNumber: this.currentSubsidiary.documentNumber,
		id: this.currentSubsidiary.id },
	'subsidiaryId',
	);
}

async function subsidiaryChange(newSubsidiary) {
	this.setId(
		{ documentNumber: newSubsidiary.documentNumber, id: newSubsidiary.id },
		'subsidiaryId',
	);
}

function setId({ documentNumber, id }, modelName) {
	this.params[modelName] = id;
	if (modelName === 'subsidiaryId') {
		this.costSubsidiary = documentNumber;
	}
	this.currentPage = 1;
	this.params.page = this.currentPage;
	this.getCostCenter();
}

function stateName({ flagActive }) {
	return flagActive === 1 ? 'Activo' : 'Inactivo';
}

function statusColorResponsive({ flagActive }) {
	return flagActive === 1 ? 'success' : 'error';
}

function colorState({ flagActive }) {
	const color = flagActive === 1 ? '#006edb' : '#ff0000';
	return `color: ${color}`;
}

async function getCostCenter() {
	const params = {
		sortDirection: 'ASC',
		flagHierarchy: 1,
	};
	try {
		this.params.page = this.currentPage;
		const response = await this.$http.get(`cost-center/${this.currentSubsidiary.id}/subsidiary`, { params });
		this.rows = response.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.rows = [];
		this.showNotification('Seleccione una empresa.', 'warning');
	}
}

async function createCost() {
	// Guarda por permiso: sin idCenter es crear; con idCenter es editar.
	const allowed = this.idCenter ? this.canEdit : this.canCreate;
	if (!allowed) {
		this.showNotification(this.idCenter
			? 'No tienes permiso para editar centros de costo'
			: 'No tienes permiso para crear centros de costo', 'warning');
		return;
	}
	this.loading = true;
	const method = this.idCenter ? 'patch' : 'post';
	const url = this.idCenter ? `cost-center/${this.idCenter}/${this.currentSubsidiary.id}` : 'cost-center';
	const action = this.idCenter ? 'editada' : 'creada';
	const body = {
		name: this.model.name,
		code: this.model.code,
		flagActive: this.model.flagActive === 1,
		account: this.model.account.code,
		accountingAccount: this.model.account,
		costCenterId: this.model.costCenterId,
		level: Number(this.model.level),
	};
	if (!this.idCenter) {
		body.subsidiaryId = this.currentSubsidiary.id;
	}
	try {
		await this.$http[method](url, body);
		this.closeModal();
		this.setId({ documentNumber: this.currentSubsidiary.documentNumber,
			id: this.currentSubsidiary.id },
		'subsidiaryId',
		);
		this.showNotification(`El centro de costo fue ${action} correctamente.`);
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		} else if (error.status === 400) {
			if (error.data.message === 'COST_CENTER_CODE_REPEATED') {
				this.showNotification('Código de centro de costo ya existente.', 'error');
			}
		}
	} finally {
		this.loading = false;
	}
}

function runAction({ code, name }) {
	if (code === 'cost-center-new') {
		// Guarda por permiso del botón (la barra ya lo oculta si no lo tiene).
		if (!this.$can(this.$route.name, 'cost-center-new')) return;
		this.action.code = code;
		this.action.title = name;
		this.action.width = 400;
		this.action.value = true;
		if (this.rows && this.rows.length > 0) {
			const maxCode = Math.max(...this.rows.map(row => parseInt(row.code, 10)));
			const newCode = String(maxCode + 1).padStart(2, '0');
			this.model.code = `${newCode}`;
			this.model.level = 1;
		} else {
			this.model.code = '01';
			this.model.level = 1;
		}
	}
}

function closeModal() {
	this.action.value = false;
	this.action.title = '';
	this.action.code = '';
	this.model = {
		code: null,
		name: '',
		state: null,
		account: {},
		costCenterId: null,
		level: null,
	};
	this.disabledCode = false;
	this.idCenter = null;
	this.loading = false;
}

function changePage(page) {
	this.currentPage = page;
	this.getCostCenter();
}

function openModalDelete({ id, name }) {
	this.centerCostId = id;
	this.dialogMessage = `¿ Estás seguro que deseas eliminar el centro de costo ${name}?`;
	this.openConfirmationModal = true;
}

function onClickIcon(action, row) {
	// Guarda por permiso según la acción del árbol.
	if (action === 'edit') {
		if (!this.canEdit) return;
		this.openModalCost(row);
	} else if (action === 'delete') {
		if (!this.canDelete) return;
		this.openModalDelete(row);
	} else if (action === 'add') {
		if (!this.canCreate) return;
		this.action.code = 'cost-center-new';
		this.action.title = 'Crear Nuevo Centro de Costo';
		this.action.width = 400;
		this.action.value = true;
		this.model.costCenterId = row.id;
		if (row.children && row.children.length > 0) {
			const maxCode = Math.max(...row.children.map(child => parseInt(child.code, 10)));
			const newCode = String(maxCode + 1).padStart(2, '0');
			this.model.code = `${row.code}.${newCode}`;
			this.model.level = row.level + 1;
		} else {
			this.model.code = `${row.code}.01`;
			this.model.level = row.level + 1;
		}
	}
}

function openModalCost({ id }) {
	this.action.value = true;
	this.action.title = 'Editar Centro de Costo';
	this.idCenter = id;
	this.editCenter(id);
}


function closeDialog() {
	this.openConfirmationModal = false;
	this.dialogMessage = '';
	this.centerCostId = null;
}

async function onDeleteCost() {
	const id = this.centerCostId;
	const body = {
		subsidiaryId: this.currentSubsidiary.id,
	};
	try {
		await this.$http.delete(`cost-center/${id}`, { data: body });
		this.showNotification('El centro de costo ha sido eliminado correctamente.');
		this.closeDialog();
		this.setId({ documentNumber: this.currentSubsidiary.documentNumber,
			id: this.currentSubsidiary.id },
		'subsidiaryId',
		);
	} catch (error) {
		if (error.status === 400) {
			if (error.data.message === 'COST_CENTER_RELATION') {
				this.showGenericError('No se puede eliminar este centro de costo, en algun asiento lo estan utilizando');
			}
		} else {
			this.showGenericError();
		}
	}
}

async function editCenter(id) {
	try {
		const { data: response } = await this.$http.get(`cost-center/${id}`);
		this.model = {
			name: response.name,
			code: response.code,
			flagActive: response.flagActive,
			account: response.accountingAccount || {},
			level: response.level,
		};
		this.disabledCode = true;
	} catch (error) {
		this.showGenericError();
	}
}

function data() {
	return {
		disabledCode: false,
		idCenter: 0,
		params: {
			page: 1,
			search: null,
		},
		subsidiaryId: null,
		listCostCenter: [],
		openConfirmationModal: false,
		dialogMessage: '',
		centerCostId: null,
		model: {
			name: '',
			code: '',
			state: '',
			account: {},
			level: null,
		},
		action: {
			code: '',
			title: '',
			value: false,
		},
		currentPage: 1,
		iconWidth: 18,
		lastPage: 0,
		rows: [],
		columns: [
			{
				id: 1,
				name: 'Código',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Nombre',
				value: 'name',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Estado',
				value: 'state',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 4,
				name: 'Acción',
				value: 'action',
				checked: true,
				visible: true,
			},
		],
		fatherId: null,
		loading: false,
	};
}

export default {
	name: 'page-costo-center',
	data,
	created,
	components: {
		actionBar,
		actionSidebar,
		appTooltipButton,
		createCostCenter,
		appActions,
		treeTable,
	},
	methods: {
		editCenter,
		createAction,
		changePage,
		closeDialog,
		closeModal,
		createCost,
		colorState,
		getCostCenter,
		onDeleteCost,
		openModalDelete,
		openModalCost,
		runAction,
		setId,
		stateName,
		statusColorResponsive,
		subsidiaryChange,
		onSearch,
		onClickIcon,
	},
	watch: {
		currentSubsidiary: subsidiaryChange,
	},
	computed: {
		...mapGetters('subsidiary', [
			'currentSubsidiary',
		]),
		permsResource,
		canNewRoot,
		canCreate,
		canEdit,
		canDelete,
	},
};
</script>


<style lang="scss" scoped>
.cost-center {
	font-family: font(AvenirRegular) !important;
	font-size: size(small11) !important;
	margin-top: 50px;
	padding-left: 48px;
	padding-right: 48px;

	@media (max-width: 1024px) {
		padding: 0;
		margin-top: 0;
	}
}

.collapse-menu {
	display: none;

	@media (max-width: 768px) {
		align-items: center;
		display: block;
		grid-column: 4 / 5;
		grid-row: 1;
		height: 100%;
		justify-content: center;

		.v-menu {
				align-items: center;
				display: flex;
				height: 100%;
				justify-content: center;

			.v-btn {
				background-color: color(btn-green);
				height: 25px;
				margin: 0;
				width: 25px;
			}
		}
	}
}

.btn-modal {
	border-radius: 30px;
	color: map-get($colors, white);
	height: 30px;
	padding: 0px 20px;
	width: 93px;
}

.save {
	background-color: color(secondary);
}

.cancel {
	background-color: color(error);
}

.actions {
	@media (max-width: 768px) {
		display: flex;
		justify-content: flex-end;
		padding-right: 13px !important;
	}
}

.state-responsive {
	display: none;

	@media (max-width: 768px) {
		bottom: 9px;
		display: block;
		position: relative;
	}
}

.state-desktop {
	@media (max-width: 768px) {
		display: none;
	}
}

.name-column {
	@media (max-width: 768px) {
		grid-column: 2/5;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/new-cost-centers/page-cost-center.vue